export const BannerType = {
	INITIAL: 'initial',
	SECONDARY: 'secondary',
	NONE: null,
} as const;
export type BannerType = (typeof BannerType)[keyof typeof BannerType];
